import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  reorderWritePageExperimentControlGroup,
  reorderWritePageExperimentTestGroup,
} from 'src/app/analytics/experiments';
import { FEATURE_REORDER_WRITE_PAGE } from 'src/app/featureToggle';
import { useFeatureToggleContext } from 'src/app/featureToggle/context/FeatureToggleContext';
import { getFeatureByName } from 'src/app/featureToggle/utils/getFeatureByName';
import { actionUpdateExperiments } from 'src/app/state/modules/tealium/experiments';

export const useExperiments = (): void => {
  const { features } = useFeatureToggleContext();
  const isReorderWritePageExperimentFeature = getFeatureByName(
    features,
    FEATURE_REORDER_WRITE_PAGE,
  );
  const isReorderWritePageExperimentEnabled =
    isReorderWritePageExperimentFeature?.enabled;

  const dispatch = useDispatch();

  useEffect(() => {
    if (isReorderWritePageExperimentEnabled !== undefined) {
      const reorderWritePageExperimentGroup =
        isReorderWritePageExperimentEnabled
          ? reorderWritePageExperimentTestGroup
          : reorderWritePageExperimentControlGroup;

      dispatch(actionUpdateExperiments([reorderWritePageExperimentGroup]));
    }
  }, [dispatch, isReorderWritePageExperimentEnabled]);
};
